<div class="sp-buyer-details-general__grid sp-min-height__full">
  <app-buyer-details-general-info *ngIf="!(is_read_running || is_document_read_running || is_sources_list_running)"
    class="sp-buyer-details-general__info" [buyer]="buyer"
    [contract_id]="last_contract_id"></app-buyer-details-general-info>

  <app-buyer-details-general-card *ngIf="!(is_read_running || is_document_read_running || is_sources_list_running)"
    class="sp-buyer-details-general__card-1" [buyer_id]="buyer_id || undefined" (refresh)="onRefresh()"
    [payment_sources]="payment_sources"></app-buyer-details-general-card>

  <app-buyer-details-general-sdd *ngIf="!(is_read_running || is_document_read_running || is_sources_list_running)"
    class="sp-buyer-details-general__card-2" [buyer_id]="buyer_id || undefined" (refresh)="onRefresh()"
    [sdd_payment_sources]="sdd_payment_sources"></app-buyer-details-general-sdd>

  <app-buyer-details-general-residency *ngIf="!(is_read_running || is_document_read_running || is_sources_list_running)"
    class="sp-buyer-details-general__residency" [buyer]="buyer"></app-buyer-details-general-residency>

  <app-buyer-details-general-document *ngIf="!(is_read_running || is_document_read_running || is_sources_list_running)"
    class="sp-buyer-details-general__document" [buyer]="buyer"
    [buyer_document_url]="buyer_document_url"></app-buyer-details-general-document>

  <app-buyer-details-general-aml *ngIf="!(is_read_running || is_document_read_running || is_sources_list_running)"
    class="sp-buyer-details-general__aml" [buyer]="buyer"></app-buyer-details-general-aml>

  <app-loading *ngIf="is_read_running || is_document_read_running || is_sources_list_running"
    class="sp-buyer-details-general__info-loading"></app-loading>

  <app-loading *ngIf="is_read_running || is_document_read_running || is_sources_list_running"
    class="sp-buyer-details-general__card-1-loading"></app-loading>

  <app-loading *ngIf="is_read_running || is_document_read_running || is_sources_list_running"
    class="sp-buyer-details-general__card-2-loading"></app-loading>

  <app-loading *ngIf="is_read_running || is_document_read_running || is_sources_list_running"
    class="sp-buyer-details-general__residency-loading"></app-loading>

  <app-loading *ngIf="is_read_running || is_document_read_running || is_sources_list_running"
    class="sp-buyer-details-general__document-loading"></app-loading>
  <app-loading *ngIf="is_read_running || is_document_read_running || is_sources_list_running"
    class="sp-buyer-details-general__aml-loading"></app-loading>
</div>